import { tv } from 'tailwind-variants';

export const styles = tv({
  base: '',
  variants: {
    state: {
      valid: 'text-green-700',
      invalid: 'text-red-700',
      loading: 'text-gray-700',
      idle: 'text-gray-700',
    },
  },
});
